//utility service

var utility = function(){

    this.queryMap = getQueryMap();
    this.isGuestRefill = false;
    this.akamaiHeaders = null;
    var x2js = new X2JS();
    this.bodyScrollPos = 0;
    this.isPageLoad = true;
    this.isSuperUser = location.host.indexOf('care.cvsspecialty.com') > -1 ? true : false;
    var spinner;
    this.enableRefreshToken = false;

    if(!('contains' in String.prototype)) {
        String.prototype.contains = function(str, startIndex) {
            return -1 !== String.prototype.indexOf.call(this, str, startIndex);
        };
    }

    this.xmlToJSON = function(xml){
         return x2js.xml_str2json(xml);

    };


    this.checkIfSuperUser = function () {
        return this.isSuperUser;
    }
        this.isPadView = function() {
        if (getHeightWidth().width >= 768) {
            return true;
        }
        return false;
    };

    this.JSONToXml = function(json){
        return x2js.json2xml_str(json);
    };

    this.sendPostMessage = function(type, serviceName){
        
    };

    this.genralPostMessage = function(type, valueObj){
            
    };

    this.showError = function(){

    };

    this.setNativeCheck = function(){ // function to check the native param from URL
        if(cvsUtility.queryMap.mobileAppStyle){
            return true;
        }
        return false;
    };

    this.getCurrentDateValues = function(){
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth() + 1;
        var currentDay = currentDate.getDate();
        var dateValues = {currentDate:currentDate,currentDay:currentDay, currentMonth:currentMonth,CurrentYear:currentYear};
        return dateValues;
    };

    this.monthList = function(){
        return [{value:'', text:'Month'},
        {value:'01', text:'January'},
        {value:'02', text:'February'},
        {value:'03', text:'March'},
        {value:'04', text:'April'},
        {value:'05', text:'May'},
        {value:'06', text:'June'},
        {value:'07', text:'July'},
        {value:'08', text:'August'},
        {value:'09', text:'September'},
        {value:'10', text:'October'},
        {value:'11', text:'November'},
        {value:'12', text:'December'},
        ];
    };

    this.monthCountList = function(){
        return [{value:'', text:'Month'},
        {value:'01', text:'01'},
        {value:'02', text:'02'},
        {value:'03', text:'03'},
        {value:'04', text:'04'},
        {value:'05', text:'05'},
        {value:'06', text:'06'},
        {value:'07', text:'07'},
        {value:'08', text:'08'},
        {value:'09', text:'09'},
        {value:'10', text:'10'},
        {value:'11', text:'11'},
        {value:'12', text:'12'},
        ];
    };

this.dayList = function (month, year) {
        var yr = (!year) ? 1975 : year;
        switch (month) {
            case '04':
            case '06':
            case '09':
            case '11':
                days = 30;
            break;

            case '02':
                if ((yr % 4 === 0) && (yr % 100 !==0) || (yr % 400 ===0)) {
                    days = 29;
                }
                else {
                    days = 28;
                }
            break;

            default:
                days =31;
            break;
        }

        var dayArray = [];
        for (day; day <= days; day++) {
           dayArray.push((day < 10) ? '0' + day : ''+day);
        }
        return dayArray;
        
    };
    this.yearsList = function (){
        var yearsList = [{value:'',text:'Year'}];
        for(var i = cvsUtility.getCurrentDateValues().CurrentYear; i<=cvsUtility.getCurrentDateValues().CurrentYear+20;i++){
            yearsList.push({value:i, text:i});
        }
        return yearsList;
    };

    this.getTimeStamp=function(dateObj){
        var date;
        if(dateObj){
            date = dateObj;
        }else{
            date = new Date();
        }
        
        var currentYear = date.getFullYear();
        var currentMonth =convertToTwoDigit(date.getMonth() + 1);
        var currentDay = convertToTwoDigit(date.getDate());

        var hour = convertToTwoDigit(date.getHours());
        var minute = convertToTwoDigit(date.getMinutes());
        var second = convertToTwoDigit(date.getSeconds());

        var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour + ':' + minute + ':' + second;
         
        return timeStamp;
    };

    this.getDateYYYYMMDD=function(dateObj){
        var date;
        if(dateObj){
            date = dateObj;
        }else{
            date = new Date();
        }
        
        var currentYear = date.getFullYear();
        var currentMonth =convertToTwoDigit(date.getMonth() + 1);
        var currentDay = convertToTwoDigit(date.getDate());

        var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay;
         
        return timeStamp;
    };

   
    function convertToTwoDigit (number) {
        return (number < 10) ? '0' + number : number;
    }

/*
    date->date to be parse
    format -> format in which date will parse
    dateSplitter-> date split with
    timeSplitter-> time split with
    isAM -> is time should be in AM or PM
    isAMSplitter -> string between time and AM or PM

*/
    this.parseDateFormat = function(date, format, dateSplitter, timeSplitter, isAM, isAMSplitter){
        var dateString = "";
        var year = date.getFullYear();
        var month =convertToTwoDigit(date.getMonth() + 1);
        var day = convertToTwoDigit(date.getDate());

        var hour = convertToTwoDigit(date.getHours());
        var minute = convertToTwoDigit(date.getMinutes());
        var second = convertToTwoDigit(date.getSeconds());
        var dateStr = format.split(" ")[0].split("-");
        var timeStr = format.split(" ")[1] ? format.split(" ")[1].split(":") : [];
        var dateSplitter = _.isUndefined(dateSplitter) ? "-" : dateSplitter;
        var timeSplitter = _.isUndefined(timeSplitter) ? ":" : timeSplitter;
        var isAM = _.isUndefined(isAM) ? false : true;
        var isAMSplitter = _.isUndefined(isAMSplitter) ? " " : isAMSplitter;

        
        for(var i=0; i< dateStr.length; i++){
            switch(dateStr[i]){
            case 'yyyy':
                dateString += year;
                break;        
            case 'mm':
                dateString += dateSplitter + month;
                break;
            case 'dd':
                dateString += dateSplitter + day; 
                break;         
            default:    
            }
        }

        for(var i=0; i< timeStr.length; i++){
            switch(timeStr[i]){           
            case 'h': 
                if(isAM){
                     dateString += " " + (hour > 12 ? hour - 12: hour);
                }else{
                    dateString += " " + hour;     
                }
                break;
            case 'm':
                dateString += timeSplitter + minute;
                break;
            case 's':
                dateString += timeSplitter + second;
                break;           
            default :
            }            
        }

        if(isAM){
            if(isAMSplitter){
                dateString += isAMSplitter + (hour >= 12 ? 'PM' : 'AM');
            }else{
                dateString += " " + (hour >= 12 ? 'PM' : 'AM');
            }                
        }

       return dateString;
    }

    this.stateList = function(){
        return [
                { text: 'AK', value: 'AK', longname: 'Alaska'},
                { text: 'AL', value: 'AL', longname: 'Alabama'},
                { text: 'AR', value: 'AR', longname: 'Arkansas'},
                { text: 'AS', value: 'AS', longname: 'American Samoa'},
                { text: 'AZ', value: 'AZ', longname: 'Arizona'},
                { text: 'CA', value: 'CA', longname: 'California'},
                { text: 'CO', value: 'CO', longname: 'Colorado'},
                { text: 'CT', value: 'CT', longname: 'Connecticut'},
                { text: 'DC', value: 'DC', longname: 'District of Columbia'},
                { text: 'DE', value: 'DE', longname: 'Delaware'},
                { text: 'FL', value: 'FL', longname: 'Florida'},
                { text: 'FM', value: 'FM', longname: 'Federated States of Micronesia'},
                { text: 'GA', value: 'GA', longname: 'Georgia'},
                { text: 'HI', value: 'HI', longname: 'Hawaii'},
                { text: 'IA', value: 'IA', longname: 'Iowa'},
                { text: 'ID', value: 'ID', longname: 'Idaho'},
                { text: 'IL', value: 'IL', longname: 'Illinois'},
                { text: 'IN', value: 'IN', longname: 'Indiana'},
                { text: 'KS', value: 'KS', longname: 'Kansas'},
                { text: 'KY', value: 'KY', longname: 'Kentucky'},
                { text: 'LA', value: 'LA', longname: 'Louisiana'},
                { text: 'MA', value: 'MA', longname: 'Massachusetts'},
                { text: 'MD', value: 'MD', longname: 'Maryland'},
                { text: 'ME', value: 'ME', longname: 'Maine'},
                { text: 'MH', value: 'MH', longname: 'Marshall Islands'},
                { text: 'MI', value: 'MI', longname: 'Michigan'},
                { text: 'MN', value: 'MN', longname: 'Minnesota'},
                { text: 'MO', value: 'MO', longname: 'Missouri'},
                { text: 'MP', value: 'MP', longname: 'Northern Mariana Islands'},
                { text: 'MS', value: 'MS', longname: 'Mississippi'},
                { text: 'MT', value: 'MT', longname: 'Montana'},
                { text: 'NC', value: 'NC', longname: 'North Carolina'},
                { text: 'ND', value: 'ND', longname: 'North Dakota'},
                { text: 'NE', value: 'NE', longname: 'Nebraska'},
                { text: 'NH', value: 'NH', longname: 'New Hampshire'},
                { text: 'NJ', value: 'NJ', longname: 'New Jersey'},
                { text: 'NM', value: 'NM', longname: 'New Mexico'},
                { text: 'NV', value: 'NV', longname: 'Nevada'},
                { text: 'NY', value: 'NY', longname: 'New York'},
                { text: 'OH', value: 'OH', longname: 'Ohio'},
                { text: 'OK', value: 'OK', longname: 'Oklahoma'},
                { text: 'OR', value: 'OR', longname: 'Oregon'},
                { text: 'PA', value: 'PA', longname: 'Pennsylvania'},
                { text: 'PR', value: 'PR', longname: 'Puerto Rico'},
                { text: 'PW', value: 'PW', longname: 'Palau'},
                { text: 'RI', value: 'RI', longname: 'Rhode Island'},
                { text: 'SC', value: 'SC', longname: 'South Carolina'},
                { text: 'SD', value: 'SD', longname: 'South Dakota'},
                { text: 'TN', value: 'TN', longname: 'Tennessee'},
                { text: 'TX', value: 'TX', longname: 'Texas'},
                { text: 'UT', value: 'UT', longname: 'Utah'},
                { text: 'VA', value: 'VA', longname: 'Virginia'},
                { text: 'VI', value: 'VI', longname: 'Virgin Islands'},
                { text: 'VT', value: 'VT', longname: 'Vermont'},
                { text: 'WA', value: 'WA', longname: 'Washington'},
                { text: 'WI', value: 'WI', longname: 'Wisconsin'},
                { text: 'WV', value: 'WV', longname: 'West Virginia'},
                { text: 'WY', value: 'WY', longname: 'Wyoming'}

            ];
    };

this.utagUrl = function (ifWebtrends) {
        var env, url;
        switch (this.queryMap.env) {
            case 'dev1':
            case 'dev2':
            case 'dev3':
                env = 'qa';
                break;
            case 'stp':
            case 'sit1':
            case 'sit2':
            case 'sit3':
                env = 'qa';
                break;
            case 'prod':
            case 'www':
                env = 'prod';
                break;
            case 'local':
                env = 'qa';
                break;
            default:
                env = 'qa';
        }
        if(ifWebtrends){
            return env;
        }
        return (url) ? url : '//tags.tiqcdn.com/utag/cvs/cvscaremarkspecialtyrx/' + env + '/utag.js';
    };

    this.getEnvironment = function () {
        var host = window.location.hostname;
        console.log(host);
        var hostValue = "";
        if (host !== 'localhost') {
            hostValue = host.substr(0, host.indexOf('.'));
        } else {
            hostValue = host;
        }
        var env = "";
        switch (hostValue) {
            case 'dev1':
            case 'dev2':
            case 'dev3':
                env = 'qa';
                break;
            case 'stp':
            case 'sit1':
            case 'sit2':
            case 'sit3':
                env = 'qa';
                break;
            case 'prod':
            case 'www':
                env = 'prod';
                break;
            case 'local':
                env = 'qa';
                break;
            default:
                env = 'qa';
        }
        return env;
    };

    this.loadScript = function (script, isSync) {
        if (script) {
            var c = 'script';
            for (var id in script) {
                var d = document.createElement(c);
                d.src = script[id];
                d.type = 'text/javascript';
                if (isSync) {
                    d.sync = true;
                }
                d.id = id;
                document.getElementsByTagName('head')[0].appendChild(d);
                return d;
            }
        }
    }

    this.relationshipList = function(){
        return [{value:'', text:'SELECT'},
        {value:'SELF (PATIENT)', text:'SELF'},
        {value:'PARENT', text:'PARENT'},
        {value:'OTHER', text:'OTHER'}];
    };

    this.dropDownFilter = function(list, val){
        return _.find(list, function(obj){
            if(obj.value == val){
                return obj;
            }

        });
    };

    this.accountNumberMasker=function(cardNumber){
        var accountNumber=this.specialCharactersTrimmer(cardNumber);
        if(accountNumber.length>=8){
            accountNumber=accountNumber.substr(accountNumber.length-4);
            return Array(13).join('x')+accountNumber;
        }else if(accountNumber.length<=4){
            return Array((8-accountNumber.length)+1).join('x')+accountNumber;
        }else if(accountNumber.length>=5 && accountNumber.length<=7){
            accountNumber=accountNumber.substr(accountNumber.length-4);
            return Array(5).join('x')+accountNumber;
        }
    };


    this.dayPostfix=function(data){
        var postFix;
        if(isNaN(data)){
            return '';
        }
        if(data%10==1 && data%100!=11)
        {
            return "st";
        }else if(data%10==2 && data%100!=12){
            return "nd";
        }else if(data%10==3 && data%100!=13){
            return "rd";
        }

        return "th";


    };

    this.specialCharactersTrimmer=function(data){
        if(data.replace(/[^0-9]/g,"").length > 0){
            return data.replace(/[^0-9]/g,"");
        }else{
            return "xxxx";
        }

    };

    this.asciiAlphabetaPattern = function() {
        var regExpAlphabets = /^[a-zA-Z]+$/,regExpAscii=/[^\u0000-\u007F]+/;
        return {
            test: function(value) {
                if(regExpAscii.test(value)){
                    return false;
                }else{
                    return regExpAlphabets.test(value);
                }
            }
        };
    };

    this.removeLineBreak = function (value) {
        value = value.replace(/\\r\\n|\\r|\\n/g, '');
        value = value.replace(/\r?\n|\r/g, '');
        return value;
    }

    this.validCreditCard = function(value) {
        if (/[^0-9-\s]+/.test(value)) return false;
        // The Luhn Algorithm. It's so pretty.
        var nCheck = 0, nDigit = 0, bEven = false;
        value = value.replace(/\D/g, "");

        for (var n = value.length - 1; n >= 0; n--) {
           var cDigit = value.charAt(n); nDigit = parseInt(cDigit, 10);

           if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
           }

           nCheck += nDigit;
           bEven = !bEven;
        }

        return (nCheck % 10) === 0;
    };

 this.getIEVersion = function () {
      msie = NaN;
      var arr = (/msie (\d+)/.exec(navigator.userAgent.toLowerCase()));
      var msie = (arr || [])[1];
    if (isNaN(msie)) {
        arr = (/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()));
        msie = (arr || [])[1];
      }

      return msie;
    };

    this.fileDownloader=function(data,filename,type){
                            Downloadify.create(type=="pdf"?"downloadify":"downloadify1",{
                                filename: function(){
                                    if(type=="csv"){
                                        return filename+".xls";
                                    }else if(type=="pdf"){
                                        return filename+".pdf";
                                    }
                                },
                                dataType: 'base64',
                                data: data,
                                onComplete: function(){ alert('Your File Has Been Saved!'); },
                                onCancel: function(){ alert('You have cancelled the saving of this file.'); },
                                onError: function(){ alert('You must put something in the File Contents or there will be nothing to save!'); },
                                swf: '../common/images/downloadify.swf',
                                downloadImage: type=="pdf"?'../common/images/download-pdf.png':'../common/images/download-excel.png',
                                width: 165,
                                height: 30,
                                transparent: true,
                                append: false
                            });
                        
    };
    /**
     * ITPR020028 - Self Enroll project - SP - 11/27/2017
     * Updated common service code to handle json response
     * @param data
     */
    this.commonServiceCode=function(url,serviceName,serviceModel,request,callBackSuccess,NS){
            if(url === "URL_ERROR"){

            }else{
                
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, getRequestBody(req), xdrSuccess);

                    
                }
                else {
                    var promise = NS.post(request); 
                    promise.then(function(data, c, d){
                        if(data.data.hasOwnProperty('selfEnrollResponse') && data.config && data.config.headers['Content-Type'] && data.config.headers['Content-Type'].indexOf('json') > -1){
                            serviceModel.setJSONResponse(data.data);
                        }
                        else{
                            serviceModel.setResponse(data.data);
                        }

                        if(data.status !== 200){
                            callBackSuccess(NS.httpError(data));
                        }else{
                            callBackSuccess(serviceModel.getResponse());
                        }
                        //send message to parent                    
                        var tokenType;
                        try{
                            //tokenType = cvsUtility.isGuestRefill;
                            /**
                             * IM5925605 - SP 06/19/2017
                             * Added condition to call session refresh only in non-guest mode and when token is avaialble.
                             */
                            if(!cvsUtility.isGuestRefill && cvsUtility.queryMap.tokenId){
                        //cvsUtility.sendPostMessage("SESSION-ALIVE",serviceName);
                            }
                        }
                        catch(ex){
                            //console.log("Exception Happened", ex);
                        }


                    }, function(reason){
                        callBackSuccess(NS.httpError(reason));
                    }); 
                }       
            }
            function xdrSuccess (data) {
                        serviceModel.setResponse(data);
                        callBackSuccess(serviceModel.getResponse());
             }
    };
    this.validateDOB=function(CIC,month,day,year, type) {
                CIC.dateInvalid=false;
                CIC.dateFormatInvalid=false;
                CIC.thirteenYearsValidation=false;
                CIC.futureDateError=false;
                if(isNaN(day) || isNaN(month) || isNaN(year) || year.length<4){
                    CIC.dateInvalid=true;
                    CIC.thirteenYearsValidation=false;
                    return;
                }
                day = parseInt(day,10);
                month = parseInt(month,10);
                year = parseInt(year,10);
                var dob = new Date(month + '/' + day + '/' + year);
                var currentDate=new Date();
                if(dob=="Invalid Date"){
                    CIC.dateInvalid=true;
                    CIC.thirteenYearsValidation=false;
                    return;
                }
                if(year > currentDate.getFullYear()){
                    CIC.futureDateError=true;
                    CIC.thirteenYearsValidation=false;
                    return;
                }if(year == currentDate.getFullYear() &&  month === (currentDate.getMonth()+1) && day >currentDate.getDate()){
                    CIC.thirteenYearsValidation=false;
                    CIC.futureDateError=true;
                    return;
                }if(year == currentDate.getFullYear() &&  month > (currentDate.getMonth()+1)){
                    CIC.thirteenYearsValidation=false;
                    CIC.futureDateError=true;
            return;
                }else {
                    var age = currentDate.getFullYear() - dob.getFullYear();
                    var m = currentDate.getMonth() - dob.getMonth();
                    if(m < 0 || (m == 0 && currentDate.getDate() < dob.getDate())) {
                        age--;
                    }

                    if (age < 13) {
                        if(type === 'parent'){
                            CIC.thirteenYearsValidation=false;
                            CIC.futureDateError=false;
                        } else {
                        CIC.thirteenYearsValidation=true;
                        CIC.futureDateError=false;
                    }

                    }
                    return;
                }
                
                
                month=this.getMonth(month-1);
                switch (month) {
                    case 'April':
                    case 'June':
                    case 'September':
                    case 'November':
                        if(day > 30) {
                            CIC.dateInvalid=true;
                            CIC.dateFormatInvalid=false;
                            CIC.thirteenYearsValidation=false;
                        }
                    break;

                    case 'February':
                        if ((year % 4 === 0) && (year % 100 !==0) || (year % 400 ===0)) {
                            if(day > 29) {
                                CIC.dateInvalid=true;
                                CIC.dateFormatInvalid=false;
                                CIC.thirteenYearsValidation=false;
                            }
                        }
                        else {
                            if(day > 28) {
                                CIC.dateInvalid=true;
                                CIC.dateFormatInvalid=false;
                                CIC.thirteenYearsValidation=false;
                            }
                        }
                    break;
                }            
        };   
    this.resetSessoinTimeOut = function(){
        var interval,userActivity;
        var idealTime = 0;
        interval=setInterval(timerIncrement,60000);
        $(document).mousemove(function(e){
                    userActivity=true;
                });
        $(document).keypress(function(e){
                    userActivity=true;
                });
        
        function timerIncrement(){
            idealTime++;
            if(idealTime==2){
                if(userActivity===true){
                    
                    userActivity=false;
                    idealTime=0;
                    clearInterval(interval);
                    interval=setInterval(timerIncrement,60000);
                }               
            }
            

        }
    };
    this.getCardType= function(number){

        // visa
        var re = new RegExp("^4");
        if (number.match(re) !== null)
            return "Visa";

        // Mastercard
        //re = new RegExp("^5[1-5]");
        //change for BSR ITPR014009, September, 2016 minor release
        //510000-559999 and 222100-272099

        //re = new RegExp("^5[1-5]|(222[1-9])[0-9][0-9]|(22[3-9][0-9])[0-9][0-9]|(2[3-6])[0-9]{4}|(27[0-1])[0-9]{3}|(2720)[0-9][0-9]");
        // Mastercard
        re = new RegExp("^(5[1-5]|2[2-7])");
        if (number.match(re) !== null && number.length==16)
            return "Mastercard";




        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) !== null)
            return "AMEX";

        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) !== null)
            return "Discover";

      // Diners
        re = new RegExp("^5[4-5]");
        if (number.match(re) !== null)
            return "Diners";

        // Diners - Carte Blanche
        re = new RegExp("3(?:0[0-5]|[68][0-9])[0-9]{11}");
        if (number.match(re) !== null)
            return "Diners - Carte Blanche";
        /*
        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null)
            return "JCB";*/

        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) !== null)
            return "Visa Electron";

        return "";
    };
    /**
     * ITPR020028 - Self Enroll project - SP - 11/27/2017
     * Updated query map logic to handle from config file
     * @param data
     */
    function getQueryMap(){
        if(!window.location.queryObj) {
            window.location.queryObj = function(){

                var source = this.search;
                 var map = {host:this.protocol + "//"+this.host+this.pathname};
                if ("" !== source) {
                    var groups = source.substr(1).split("&"), i;

                    for (i in groups) {
                        i = groups[i].split("=");
                        map[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
                    }
                 }
                    map["env"] = !map["env"] ?  envService.getEnvironment() : map["env"];
                    map["apikey"] = !map["apikey"] ? envService.getapikey() : map["apikey"];
                    map["channel"] = !map["channel"] ?  envService.getChannel() : map["channel"];
                    // map["tSwitch"] = envService.getTSwitch()
                    // map["tokenId"] = envService.getTokenId()
                    map["parentHost"] = !map["parentHost"] ? envService.getParentHost() : map["parentHost"];
                    map["smagentname"] = !map["smagentname"] ? envService.getSmagentname() : map["smagentname"];
                    // map["accessKey"] = envService.getAccessKey()
                    // map["source"] = envService.getSource()
                    // map["mobileAppStyle"] = envService.getAppStyle()
                    // map["hashkey"] = envService.getHashkey()
                    // map["timestamp"] = envService.getTimestamp()
                // }

                return map;
            };
        }
        return window.location.queryObj();
    }

    this.setAkamaiHeaders = function(header){
        var akamaiHeaders = {};
        //Process akamai headers
        if(header['x-akamai-edgescape'] || header['X-Akamai-Edgescape']){
            var edgsscapeHeader = header['x-akamai-edgescape'] || header['X-Akamai-Edgescape'];
            var edgescapeArr = edgsscapeHeader.split(',');
            $.each(edgescapeArr, function(index, locHeader){
               akamaiHeaders[locHeader.split('=')[0]] = locHeader.split('=')[1];
            });
        }
        if(header['cvs-akclient-ip'] || header['CVS-AKCLIENT-IP']){
            akamaiHeaders['cvs-akclient-ip'] = header['cvs-akclient-ip'] || header['CVS-AKCLIENT-IP'];
        }

        if(header['cookie']){
            var cookieInfo = header['cookie'];

           var loginTrys = _.find(_.map(cookieInfo.split(";")), function(obj){var key = obj.split("=")[0]; if(key.indexOf("SMTRYNO")>-1){return obj;}});
                akamaiHeaders.SMTRYNO = (loginTrys && loginTrys.indexOf("=") > -1) ? (!isNaN(loginTrys.split('=')[1]) ? parseInt(loginTrys.split('=')[1]) : 0)  : 0
        }


        this.akamaiHeaders = akamaiHeaders;
    }

    this.getAkamaiHeaders = function(){
        return this.akamaiHeaders;
    }

    this.updateQueryParam = function(url, param, value){
        var regEx = new RegExp('('+param+'=)[^\&]+');
        return url.replace(regEx, '$1'+value);
    }

    this.dateMaskingDDMMYYY = function(CIC,e, check){
        var v = e.target.value;
        
        var keyCode=e.keyCode || e.charCode;
        if(keyCode !== 8){
            if(keyCode==191){
                if(v.charAt(0)=="/"){
                    e.target.value="";
                }else if(v.length >0 && v.length<2){
                    e.target.value="0"+v.charAt(0)+"/";
                }
                else if(v.charAt(3)=='/'){
                    v=v.substr(0,3)+v.substr(4);
                    e.target.value=v;
                }else if(v.charAt(1)=='/'){
                    if(v.charAt(0)==0){
                        e.target.value="0";
                    }else{
                         e.target.value="0"+v.charAt(0)+'/';
                    }
                }else if(v.charAt(4)=="/"){
                     e.target.value=v.charAt(0)+v.charAt(1)+v.charAt(2)+"0"+v.charAt(3)+'/';
                }else{
                    if(v.lastIndexOf('/')>5){
                        v=v.substr(0,v.lastIndexOf('/'))+v.substr(v.lastIndexOf('/')+1);
                        e.target.value=v;
                    }
                }

            }
            if(check){
                if(v.charAt(2) !=='/'){
                  e.target.value= v.charAt(0)+v.charAt(1)+"/"+ v.charAt(2)+v.charAt(3);
                }
                if(v.charAt(2) =='/' && v.charAt(5) !=='/'){
                  e.target.value= v.charAt(0)+v.charAt(1)+"/"+ v.charAt(3)+v.charAt(4) + "/";
                }
            }
            if(v.charAt(0)=="0" && v.charAt(1)=="0"){
                e.target.value="";
                if(v.length>2){
                    for(var i=0;i<v.length;i++){
                        if(i===1){
                            e.target.value+="1";
                        }else{
                            e.target.value+=v.charAt(i);
                        }
                        
                    }
                    v=e.target.value;
                }else{
                     e.target.value="0";
                      v=e.target.value;
                }
            }
            if(v.charAt(3)=="0" && v.charAt(4)=="0"){
                e.target.value="";
                if(v.length>5){
                    for(var i=0;i<v.length;i++){
                        if(i===4){
                            e.target.value+="1";
                        }else{
                            e.target.value+=v.charAt(i);
                        }
                        
                    }
                    v=e.target.value;
                }else{
                        e.target.value=v.substr(0,4);
                        v=e.target.value;
                }
            }
            if(v.charAt(0)==1 && v.charAt(1)>"2"){
                e.target.value="";
                if(v.length>2){
                    for(var i=0;i<v.length;i++){
                        if(i===1){
                            e.target.value+="2";
                        }else{
                            e.target.value+=v.charAt(i);
                        }
                        
                    }
                    v=e.target.value;
                }else{
                     e.target.value="1";
                      v=e.target.value;
                }
                
            }
            if(v.charAt(3)>1 && v.charAt(3)<=3){
                month=this.getMonth(parseInt(v.substr(0,2),10)-1);
                switch (month) {
                    case 'April':
                    case 'June':
                    case 'September':
                    case 'November':
                        if(v.charAt(3)==3 && v.charAt(4)>0) {
                            e.target.value="";
                            if(v.length>5){
                                for(var i=0;i<v.length;i++){
                                    if(i===4){
                                        e.target.value+="0";
                                    }else{
                                        e.target.value+=v.charAt(i);
                                    }
                                    
                                }
                                v=e.target.value;
                            }else{
                                    e.target.value=v.substr(0,4);
                                    v=e.target.value;
                            }
                        }
                                
                    break;

                    case 'February':
                        
                            if(v.charAt(3)==2 && v.charAt(4)>9) {
                                e.target.value="";
                                if(v.length>5){
                                    for(var i=0;i<v.length;i++){
                                        if(i===4){
                                            e.target.value+="9";
                                        }else{
                                            e.target.value+=v.charAt(i);
                                        }
                                        
                                    }
                                    v=e.target.value;
                                }else{
                                        e.target.value=v.substr(0,4);
                                        v=e.target.value;
                                }
                            }
                    break;
                    case 'January':
                    case 'March':
                    case 'May':
                    case 'July':
                    case 'August':
                    case 'October':
                    case 'December':
                        if(v.charAt(3)==3 && v.charAt(4)>1) {
                            e.target.value="";
                            if(v.length>5){
                                for(var i=0;i<v.length;i++){
                                    if(i===4){
                                        e.target.value+="1";
                                    }else{
                                        e.target.value+=v.charAt(i);
                                    }
                                    
                                }
                                v=e.target.value;
                            }else{
                                    e.target.value=v.substr(0,4);
                                    v=e.target.value;
                            }
                        }
                    break;
                }          
            }
            if(v.charAt(0)>"1"){
                e.target.value="";
                for(var i=0;i<v.length;i++){
                    if(i===0){
                        e.target.value+="0"+v.charAt(0);
                    }else{
                        e.target.value+=v.charAt(i);
                    }
                    
                }
                v=e.target.value;
            }
            if(v.charAt(3)>"3" && v.charAt(2)=="/"){
                 e.target.value="";
                for(var i=0;i<v.length;i++){
                    if(i===3){
                        e.target.value+="0"+v.charAt(3);
                    }else{
                        e.target.value+=v.charAt(i);
                    }
                    
                }
                v=e.target.value;
            }
            if(v.match(/^\d{2}$/) !== null){
                e.target.value = v + '/';        
            }else if(v.match(/^\d{2}\/\d{2}$/) !== null){
                e.target.value = v+ '/';
            }else{
               
                if(v.match(/^\d{3}$/) || v.match(/^\d{2}\/\d{3}$/))
                   e.target.value = v.slice(0,-1)+'/'+v.substring(v.length-1,v.length); 
            }

            var dobDay = v.charAt( 3 ) + "" + v.charAt( 4 );
            var dobMonth = v.charAt( 0 ) + "" + v.charAt( 1 );
            var targetdays = 30;
            if (
                (dobMonth == "01") ||
                (dobMonth == "03") ||
                (dobMonth == "05") ||
                (dobMonth == "07") ||
                (dobMonth == "08") ||
                (dobMonth == "10") ||
                (dobMonth == "12") 
            ) { targetdays=31; }
            else if (dobMonth == "02") { targetdays=29; }
            else { targetdays=30; }
            if (dobDay > targetdays) {
                e.target.value = v.charAt(0)  + v.charAt(1) + v.charAt(2) + v.charAt(3);
            }
            if (CIC) {
                e.target.value = e.target.value.replace(/\/+/g, '/')
                CIC.dateOfBirth=e.target.value;
            }
            else {
                return e.target.value;
            }
        }else if(keyCode=="191"){

        }
        else {
            return e.target.value;
        }
    };
    this.allowOnlyNumbers=function($event){ 
        $event = $event ? $event : window.event;
        var keyCode= $event.keyCode ||  $event.charCode;
        if ((keyCode > 31 && !$event.shiftKey && ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105))) ||
            keyCode == 8 || keyCode == 9 || keyCode == 37 || keyCode == 39 || keyCode == 46
        )
             { 
        } else   {
            $event.preventDefault();
        }
    };
    this.testUpperCase = function(val){
        if(/[A-Z]/.test(val)){
            return true;
        }
        //retuen false;
    };

    this.testNumbers = function(val){
        if(/[0-9]/.test(val)){
            return true;
        }
        //retuen false;
    };
    this.aesEncryption=function(message,encKey){
        var key = CryptoJS.enc.Utf8.parse(encKey.substring(0,16));
        var encrypted = CryptoJS.AES.encrypt(message, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });      
        var ciphertext = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        return ciphertext;
    };
    this.isMobile=function(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            return true;
        }
        return false;
    };

    this.isIpad=function(){
        if(/tablet|iPad|playbook|silk/i.test(navigator.userAgent) ) {
            return true;
        }
        return false;
    };
    this.isAndroid = function(){
        if(/Android/i.test(navigator.userAgent) ) {
            return true;
        }
        return false;
    }

    this.isIOS = function() {
        if (/iPhone/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    }

    this.getWindowWidth=function(){
        return getHeightWidth().width;
    };

    

    this.getMonth=function(n){
        var months=["January","February","March","April","May","June","July","August","September","October","November","December"];
        return months[n];
    };
    this.getDay=function(n){
        var days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        return days[n];
    };
    this.addHardcodingTag = function(v){
        angular.forEach(v, function(value, key) {
                    this[key]= value;
                }, v);  
        return v;
    };

    this.openPopUp = function(modal, url, scope, prop, className, title){
        var primeObj = {
                    templateUrl: url,
                    controller:'commonPopUpController',             
                    backdrop:"static",
                    ariaLabelledBy:title || "",
                    size: "lg",
                    animation:true,
                    windowClass:className,
                    resolve: {parentScope:function(){return scope}}
                };
           if(prop){
                 primeObj = _.extend(primeObj, prop);  
           }     
              
        angular.element('#rx-help').parent().css({'border':'none','background-color':'transparent'})
        angular.element('#rx-help').parent().parent().css({'border':'none','background-color':'transparent'});    
        if(this.setNativeCheck()){
            try{
            native.disableHeader();
        }catch(ex){}
        }        
        var modalInstance = modal.open(primeObj);
        // setTimeout(function() {
        //
        // }, 300);
        return modalInstance;
    };
    this.getRedirecttoLogin = function(contextInfo){
       if(contextInfo && (contextInfo=="OLP-BD" || contextInfo=="OLP-PS" || contextInfo=="OLP" ||
            contextInfo=="PS" || contextInfo=="BD" )){
            contextInfo="OP";
        }

        if(contextInfo.contains("OLP")){
            contextInfo="OP";
        }
        if(contextInfo){
            var channelUrl = "";
            var isRedirect = false;
            if((contextInfo.toUpperCase()==='RFR')){
                channelUrl = createChannelUrl('rfrlogin');
            }else if((contextInfo.toUpperCase()==='OP')){
                channelUrl = createChannelUrl('oplogin');
            } else  if((contextInfo.toUpperCase()==='QR')){
                channelUrl = createChannelUrl('qrlogin');
            }else  if((contextInfo.toUpperCase()==='TAP')){
                channelUrl = createChannelUrl('taplogin');
            }
            var qrlogin = channelUrl,
                         key =  "&accessKey="+cvsUtility.queryMap.accessKey,
                        source="&source="+cvsUtility.queryMap.source,
                        cadence = cvsUtility.queryMap.hasOwnProperty('cadence') ? '&cadence='+cvsUtility.queryMap.cadence : ''
                         redirectUrl = qrlogin;
                         if(cvsUtility.queryMap.accessKey){
                            redirectUrl = qrlogin+key+source+cadence;
                         }
            return redirectUrl;
        }
    }

    this.maskPhone = function (val) {
        var zChar = new Array(' ', '(', ')', '-', '.');
        var maxphonelength = 12;
        var phonevalue1;
        var cursorposition;

        //phonevalue1 = parseChar(val, zChar);

        for (var i = 0; i < zChar.length; i++) {
            var sNewStr = "";
            
            var iStart = 0;
            var iEnd = val.indexOf(zChar[i]);
            
            while (iEnd != -1){
                sNewStr += val.substring(iStart, iEnd);
                iStart = iEnd + 1;
                iEnd = val.indexOf(zChar[i], iStart);
            }
            sNewStr += val.substring(val.lastIndexOf(zChar[i]) + 1, val.length);
            
            val = sNewStr;
        }
        
        var p = val;
        p = p.replace(/[^\d]*/gi, "")
        
        if (p.length < 3) {
            return p;
        } else if (p.length == 3) {
           var pp = p;
           var d4 = p.indexOf('(')
           var d5 = p.indexOf(')')
            if (d4 == -1) {
            //pp=" "+pp;
            }
            if (d5 == -1) {
                pp = pp + "-";
            }
            return pp;
        } else if (p.length > 3 && p.length < 7) {
            //p =" " + p; 
            var l30 = p.length;
            var p30 = p.substring(0, 3);
            p30 = p30 + "-"
            
            var p31 = p.substring(3, l30);
            pp = p30 + p31;
            
            return pp;
        
        } else if (p.length >= 7) {
            //p =" " + p; 
            var l30 = p.length;
            var p30 = p.substring(0, 3);
            p30 = p30 + "-"
            
            var p31 = p.substring(3, l30);
            pp = p30 + p31;
            
            var l40 = pp.length;
            var p40 = pp.substring(0, 7);
            p40 = p40 + "-"
            
            var p41 = pp.substring(7, l40);
            var ppp = p40 + p41;
            
            return ppp.substring(0, maxphonelength);
        }
        
    };
    /*Needs to be removed in later point right now we are at last stage no not removing*/
    this.componentName= function(){
        if(!window.location.componentName) {
            window.location.componentName = function(){
                var hash = window.location.hash; //Puts hash in variable, and removes the # character
                var path = this.pathname;
                var componentName='OTHER';
                if(hash.toUpperCase().contains('MYACCOUNT')){
                    componentName="myAccount";
                }else
                if(path.contains('readyforrefill')){
                    componentName="RFR";
                }
                else if(path.contains('recentorder')){
                    componentName="RO";
                }
                else if(path.contains('quickregistration')){
                    componentName="QR";
                }else if(path.contains('payments')){
                    componentName="OLP";
                }

                return componentName;
            };
        }
        return window.location.componentName();
    }

    this.invokeSpinner=function(){
        
        var opts = {
            lines: 12 // The number of lines to draw
            , length: 28 // The length of each line
            , width: 10 // The line thickness
            , radius: 12 // The radius of the inner circle
            , scale: 1.00 // Scales overall size of the spinner
            , corners: 0.5 // Corner roundness (0..1)
            , color: '#000' // #rgb or #rrggbb or array of colors
            , opacity: 0.75 // Opacity of the lines
            , rotate: 54 // The rotation offset
            , direction: 1 // 1: clockwise, -1: counterclockwise
            , speed: 1.6 // Rounds per second
            , trail: 66 // Afterglow percentage
            , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
            , zIndex: 2e9 // The z-index (defaults to 2000000000)
            , className: 'spinner' // The CSS class to assign to the spinner
            , top: '49%' // Top position relative to parent
            , left: '48%' // Left position relative to parent
            , shadow: false // Whether to render a shadow
            , hwaccel: false // Whether to use hardware acceleration
            , position: 'absolute' // Element positioning
        }
        //var target = document.getElementById('App3');
        //var target1 = document.getElementById('progress_wheel_div');
       // spinner = new Spinner(opts).spin(target);
        //target.appendChild(spinner.el);
        //target1.show();
    };

    this.stopSpinner=function(){
        spinner.stop();
        //var target1 = document.getElementById('progress_wheel_div');
        //target1.hide();
        
    }

    this.maxDecimalsDigit = function(maxDecimals,val) {
        var regexString, validRegex;
        if (maxDecimals > 0) {
            //regexString = "^-?\\d*\\.?\\d{0," + maxDecimals + "}$";
            regexString = "^-?\\d*\\.?\\d{0," + maxDecimals + "}$";
        } else {
            regexString = "^-?\\d{10}$";
        }
        validRegex = new RegExp(regexString);

        return validRegex.test(val);

    };
    this.makeMaxDigits = function(maxDigits,val) {
        var validRegex;
        validRegex = new RegExp("^-?\\d{0," + maxDigits + "}(\\.\\d*)?$");

            return validRegex.test(val);

    };

    /*this.isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (cvsUtility.isMobile.Android() || cvsUtility.isMobile.BlackBerry() || cvsUtility.isMobile.iOS() || cvsUtility.isMobile.Opera() || cvsUtility.isMobile.Windows());
        }
    };*/
    this.getPlatform = function(){
    var platform = '';
    if (navigator.userAgent.match(/Tablet|iPad/i)){
        platform = 'tweb';
    }else if(navigator.userAgent.match(/IEMobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Mobile Safari|Opera Mini|\bCrMo\/|Opera Mobi/i)){
        if(cvsUtility.queryMap.mobileAppStyle==true || cvsUtility.queryMap.mobileAppStyle=="true") {
            platform = 'mapp';
       }else{
            platform = 'mweb';
       }
    } else {
        platform = 'dweb';
    }
    return platform;
}


    this.getPageError = function(data, fatalStatus, serviceName){
        try{
        var error_data = '';
        if(data.SERVER_ERROR){
            error_data = fatalStatus + '_' + serviceName + '_' + data.SERVER_STATUS + '_' + data.SERVER_DESC;
        }
        else if(data.apiResponse && data.apiResponse.showError)
        {
            var refId = '';
            refId = (data.apiResponse.showError.hasOwnProperty('refId') ? data.apiResponse.showError.refId :
                    data.apiResponse.showError.hasOwnProperty('refID') ? data.apiResponse.showError.refID :''
            );
            error_data = fatalStatus + '_' + serviceName + '_' + (data.apiResponse.showError.statusCode ? data.apiResponse.showError.statusCode : data.apiResponse.showError.status) + '_' + data.apiResponse.showError.statusDesc;
        }
        else if(data.getError() != "")
        {
            var refId = '';
            refId = (data.getError().hasOwnProperty('refId') ? data.getError().refId :
                    data.getError().hasOwnProperty('refID') ? data.getError().refID :''
            );
            error_data = fatalStatus + '_' + serviceName + '_' + (data.getError().statusCode ? data.getError().statusCode : data.getError().status) + '_' + data.getError().statusDesc;
        }
        else if(data.statusCode){
                error_data = fatalStatus + '_' + serviceName + '_' + data.statusCode + '_' + data.statusDesc;
            }
        return error_data;
        }
        catch(ex){}
        return null;
    }

    this.mobilecheck = function () {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))check = true
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }



    this.memberStatus = 'Registration Status Unknown';
    this.setMemberstatus = function(b){
        this.memberStatus = b;
    }
    this.getMemberstatus = function(){
        return this.memberStatus;
    }

    this.patientId = '';
    this.setPatientId = function(d){

        this.patientId=d;
    }
    this.getPatientId = function(){
        return this.patientId;
    }

    this.alignModalinPortalMob = function(modalClass){
        if(this.mobilecheck() && parent !== window){
            //$('.'+modalClass).css('padding-top', 50);
            if(modalClass !== 'terms-condition'){
            var scrollPos = window.parent.window.pageYOffset || window.parent.document.body.scrollTop;
            $('.'+modalClass).css('top', (scrollPos ) > 0 ? (scrollPos ): 0);
            }
        $('body',window.parent.document).css('overflow', 'hidden');
        }
    }

    this.alignModalinPortal = function(modalInstance, modalClass){
        if(this.mobilecheck() && parent !== window){
            modalInstance.rendered.then(function(){
                cvsUtility.alignModalinPortalMob(modalClass);
                if(modalClass === 'or-insurencePopUp' || modalClass === 'or-changeAddressPopUp' || modalClass === 'saveChanges'){
                    $('.'+modalClass).css('padding-top', 50);
                }
                // $('.refill-dashboard-popup').css('padding-top', 50);
            });
            modalInstance.result.then(function(){
                $('body',window.parent.document).css('overflow', 'auto');

            }, function(){
                if(parent !== window)
                    $('body',window.parent.document).css('overflow', 'auto');
            });
        }
        else if(parent !== window){
            cvsUtility.bodyScrollPos = window.parent.window.pageYOffset || window.parent.document.body.scrollTop;
            // $('body',window.parent.document).scrollTop(0);
            window.parent.window.scroll(0,0);
            modalInstance.result.then(function(){
                    window.parent.window.scroll(0, cvsUtility.bodyScrollPos);
                },
                function(){
                    window.parent.window.scroll(0, cvsUtility.bodyScrollPos);
                });

        }
    }

    /**
     * HTTP Security header - Nov 2017 release - SP 11062017
     * Created dedicated method clearing Rx session elements
     */
    this.clearRxSession = function() {
        var inclusionKeys = Object.getOwnPropertyNames(sessionStorage).filter(function (key) {
            return key === 'depToken' || key === 'open';
        });
        var sessionData = Object.getOwnPropertyNames(sessionStorage);
        if (sessionData && sessionData.length) {
            _.each(sessionData, function (item) {
                if (inclusionKeys.indexOf(item) === -1) {
                    sessionStorage.removeItem(item);
                }
            });

        }
    };

    /**
     * ITPR023507 - EPIC SSO project - Mar 2018 release - SP 12292017
     * Added new method to check WCM switch.
     * @param wcmContentObj
     * @param componentName
     * @returns {boolean}
     */
    this.checkIfComponentEnabled = function(wcmContentObj, componentName, ctaObj) {
        var isComponentEnabled = true;
        var deviceType="desktop";
        if(cvsUtility.queryMap.mobileAppStyle!=undefined && (cvsUtility.queryMap.mobileAppStyle==true || cvsUtility.queryMap.mobileAppStyle=="true")) {
            /****checking for mobile web****/
            deviceType="mobileApp";
        }else if( cvsUtility.isMobile()){
            /****checking for mobile App****/
            deviceType="mobile";
        }
        if(wcmContentObj && wcmContentObj.fast_config && wcmContentObj.fast_config.component_config) {
            var configValues = wcmContentObj.fast_config.component_config.hasOwnProperty('config') ? wcmContentObj.fast_config.component_config.config : wcmContentObj.fast_config.component_config;
            for (var configIndex = 0; configIndex < configValues.length; configIndex++) {
                if(configValues[configIndex].componentname == componentName){
                    switch(deviceType) {
                        case "mobile":
                            if(configValues[configIndex].channelswitches.mobileweb.toUpperCase() ==="N"){
                                isComponentEnabled = false;
                            }
                            break;
                        case "mobileApp":
                            if(configValues[configIndex].channelswitches.mobileapp.toUpperCase()==="N"){
                                isComponentEnabled = false;
                            }
                            break;
                        default:
                            if(configValues[configIndex].channelswitches.desktop.toUpperCase()==="N"){
                                isComponentEnabled = false;
                            }
                            break;
                    }
                    break;
                }
            }
        } 
        /* SPEC-95 Prompt for SMS opt-in after refill */
        else if (ctaObj) {
            switch (deviceType) {
                case "mobile":
                    if (ctaObj.channelFlags.mweb.toUpperCase() === "N") {
                        isComponentEnabled = false;
                    }
                    break;
                case "mobileApp":
                    if (ctaObj.channelFlags.mapp.toUpperCase() === "N") {
                        isComponentEnabled = false;
                    }
                    break;
                default:
                    if (ctaObj.channelFlags.desktop.toUpperCase() === "N") {
                        isComponentEnabled = false;
                    }
                    break;
            }
        }
        return isComponentEnabled;
    };

    this.checkAndRedirect = function () {
        var tokenId = $('.spltyTokenId', window.parent.document).val();
        if (parent != window && parent.location.pathname.indexOf('/quickregistration/') === -1 && tokenId != null && tokenId != '') {
            var portalSession = {}
            var secureChatAttrs = {}
            var userAttrs = {}
            var portalSessionActiveUrl = parent.portalSessionActiveUrl;
            var portalSessionUrl = portalSessionActiveUrl.substring(0, portalSessionActiveUrl.indexOf('/id='));
            var logoutUrl = parent.signOutUrl;
            var lastLoggedIn = $('.lastloginTimeWeb', window.parent.document).first().text();
            var userName = $('.wpthemeNavListItem span', window.parent.document).first().text();
            
            var userType = $('.userType', window.parent.document).val();
            var showEpicMyChartLink = $('.showEpicMyChartLink', window.parent.document).val();
            var hidePaymentsforCATSUsers = $('.hidePaymentsforCATSUsers', window.parent.document).val();
            var portalSession = {
                portalSessionUrl: portalSessionUrl,
                logoutUrl: logoutUrl,
                tokenId: tokenId
                
            }
            userAttrs = {
                
                lastLoggedIn: lastLoggedIn,
                userName: userName,
                userType: userType,
                showEpicMyChartLink: showEpicMyChartLink,
                isCatsPatient: hidePaymentsforCATSUsers && hidePaymentsforCATSUsers.toLowerCase() === 'false' ? 'N' : 'Y'
            }

            var expireDate = new Date();
            expireDate.setMinutes(expireDate.getMinutes() + 30);
            document.cookie = "portalSession=" + JSON.stringify(portalSession) + "; path=/; secure=true;";
            document.cookie = "userAttrs=" + JSON.stringify(userAttrs) + "; path=/; secure=true;";
            document.cookie = "redirectionQuery=" + JSON.stringify(location.queryObj()) + ";expires=" + expireDate.toUTCString() + "; path=/; secure=true;";
            window.parent.location = location.origin + '/FASTPROXY/patients/#/'+CVS.Config.fastURLMapping[location.pathname.replaceAll("/","").replace('FASTPROXY', "")];
            return false;
        }
        else {
            return true;
        }
    };

    this.updatePageTitle = function (pageName) {
        if (CVS.Config.patientsPageTitles) {
            var patientsPageTitle = CVS.Config.patientsPageTitles[pageName];
            if (!patientsPageTitle) {
                patientsPageTitle = CVS.Config.patientsPageTitles[""];
            }
            window.document.title = patientsPageTitle.pageTitle;
            $.announce(window.document.title);
        }
    }
    /**
     * 
     * @param {*} isFEPUser 
     * @param {*} isFEPFAQUser
     * @param {*} url 
     */
     this.checkIfFepClient = function (isFEPUser) { 
        //check for native 
        if (cvsUtility.setNativeCheck()) {
            if (isFEPUser == true) {
                var fepUrl = window.location.origin + '/contact-us-fep.html';
                native.openExtUrl(fepUrl);
            } else if (isFEPUser == false) {
                var contactUrl = window.location.origin + '/contact-us.html';
                native.openExtUrl(contactUrl);
            }
        } else {
            //check FEP client
            if (isFEPUser == true) {
                window.location.href = window.location.origin + '/contact-us-fep.html';
            } else if (isFEPUser == false) {
                window.location.href = window.location.origin + '/contact-us.html';
            }
            //If both fail defualt should be contact us page
            else {
                window.location.href = window.location.origin + '/contact-us.html';
            }
        }
    }
    
    this.checkIfFepClientFAQ = function ( isFEPFAQUser) {
        //check for native
        if (cvsUtility.setNativeCheck()) {           
            if (isFEPFAQUser == true) {
                var FepFaqUrl = window.location.origin + '/faq-fep.html';
                native.openExtUrl(FepFaqUrl);
            } else if (isFEPFAQUser == false) {
                var faqUrl = window.location.origin + '/faq.html';
                native.openExtUrl(faqUrl);
            }
        } else {
            //check FEP client
            if (isFEPFAQUser == true) {
                window.location.href = window.location.origin + '/faq-fep.html';
            } else if (isFEPFAQUser == false) {
                window.location.href = window.location.origin + '/faq.html';
            }
            //If both fail defualt should be contact us page
            else {
                window.location.href = window.location.origin + '/faq.html';
            }
        }
    }

    this.checkIsTokenExpire = function (expireTtl) {
        //Read browser session storage
        if(expireTtl && expireTtl != ''){
        //Read current date
          var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          var expire = d.setUTCSeconds(Number(expireTtl)-60);
          //console.log(new Date(expire));
          //comparing current date with browser session expiry 
          if(new Date(expire) < new Date()){
                return true;
          }
        }

        return false;

    }

};


var cvsUtility = new utility();

//creating links according to channel
function createChannelUrl (url, origin){
    if(url){
        var channel;
        var finalURL = '';
        if(cvsUtility.queryMap.channel.indexOf('Web') !== -1) {
            channel = 'Web';
        }
        var parentHost = CVS.Config.parentHost[channel][cvsUtility.queryMap.env];
        if(cvsUtility.queryMap.parentHost){
            parentHost = cvsUtility.queryMap.parentHost;
        }
        finalURL = parentHost + CVS.Config.redirectUrls[channel][url];
        if(origin && origin !== undefined){
            finalURL = finalURL.indexOf('?') === -1 ? finalURL+'?icid='+origin : finalURL+'&icid='+origin;
        }
        return finalURL
    }

}

function createTimestamp(){
    function convertToTwoDigit (number) {
        return (number < 10) ? '0' + number : number;
    }
    var date = new Date();
    var currentYear = date.getFullYear();
    var currentMonth =convertToTwoDigit(date.getMonth() + 1);
    var currentDay = convertToTwoDigit(date.getDate());

    var hour = convertToTwoDigit(date.getHours());
    var minute = convertToTwoDigit(date.getMinutes());
    var second = convertToTwoDigit(date.getSeconds());

    var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour
        + ':' + minute + ':' + second;
    return timeStamp;
}

function getParentHost(){
    var channel;
    if(cvsUtility.queryMap.channel.indexOf('Web') !== -1) {
            channel = 'Web';
        }
    var parentHost = CVS.Config.parentHost[channel][cvsUtility.queryMap.env];
    if(cvsUtility.queryMap.parentHost){
        parentHost = cvsUtility.queryMap.parentHost;
    }
    return parentHost;
}

function getBrowser(){
    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';
    // At least Safari 3+: "[object HTMLElementConstructor]"
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;
    // Chrome 1+
    var isChrome = !!window.chrome && !!window.chrome.webstore;
    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

}

function getBrowserDetails(){
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

// In Opera 15+, the true version is after "OPR/"
    if ((verOffset=nAgt.indexOf("OPR/"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
    }
// In older Opera, the true version is after "Opera" or after "Version"
    else if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+6);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
// In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
    }
// In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
    }
// In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
// In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset+8);
    }
// In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
        (verOffset=nAgt.lastIndexOf('/')) )
    {
        browserName = nAgt.substring(nameOffset,verOffset);
        fullVersion = nAgt.substring(verOffset+1);
        if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
// trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
        fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
        fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
        fullVersion  = ''+parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion,10);
    }
    /*{browserName:browserName,fullVersion:fullVersion,majorVersion:majorVersion,appName:navigator.appName,userAgent:navigator.userAgent};*/
    return navigator.userAgent;
}


// update popover template for binding unsafe html
angular.module("template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/popover/popover.html",
      "<div class=\"popover popoverImage {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
      "  <div class=\"arrow\"></div>\n" +
      "\n" +
      "  <div class=\"popover-inner\">\n" +
      "      <h3 class=\"popover-title\" ng-bind-html=\"title | unsafe\" ng-show=\"title\"></h3>\n" +
      "      <div class=\"popover-content\"ng-bind-html=\"content | unsafe\"></div>\n" +
      "  </div>\n" +
      "</div>\n" +
      "");
}]);

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

var getTimeout=function(serviceName){
    if(CVS.Config && CVS.Config.timeout && CVS.Config.timeout[serviceName]){
        return CVS.Config.timeout[serviceName];
    }else{
        return CVS.Config.timeout.default;
    }
};

var componentName= function(){
    if(!window.location.componentName) {
        window.location.componentName = function(){
            var hash = window.location.hash; //Puts hash in variable, and removes the # character
            var path = this.pathname;
            var componentName='OTHER';
            if(hash.toUpperCase().contains('MYACCOUNT')){
                componentName="myAccount";
            }else
            if(path.contains('readyforrefill')){
                componentName="RFR";
            }
            else if(path.contains('recentorder')){
                componentName="RO";
            }
            else if(path.contains('quickregistration')){
                componentName="QR";
            }else if(path.contains('payments')){
                componentName="OLP";
            }

            return componentName;
        };
    }
    return window.location.componentName();
}

var getHeightWidth=function(){
    var myWidth = 0, myHeight = 0;
        if( typeof( window.innerWidth ) == 'number' ) {
            //Non-IE
            myWidth = window.innerWidth;
            myHeight = window.innerHeight;
        } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
            //IE 6+ in 'standards compliant mode'
            myWidth = document.documentElement.clientWidth;
            myHeight = document.documentElement.clientHeight;
        } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
            //IE 4 compatible
            myWidth = document.body.clientWidth;
            myHeight = document.body.clientHeight;
        }
        return {"height":myHeight,"width":myWidth};
}


var scrollToErrors = function(form) {
    if (form.$error) {
        var error = form.$error;
        if (error.required) {
            angular.forEach(error.required, function(i, error) {
                if (i.$invalid === true && error === 0) {
                    /*This is for input field validation*/
                    if(angular.element('input.ng-invalid') && angular.element('input.ng-invalid').length>0){
                        angular.element('input.ng-invalid')[0].focus();
                    } else if(angular.element('input.ng-invalid')){
                        angular.element('input.ng-invalid').focus();
                    }
                    /*This is for select field validation*/
                    else if(angular.element('select.ng-invalid') && angular.element('select.ng-invalid').length>0){
                        angular.element('select.ng-invalid')[0].focus();
                    }else if(angular.element('select.ng-invalid')){
                        angular.element('select.ng-invalid').focus();
                    }
                }
            });
        } else if (error.minlength) {
            angular.forEach(error.minlength, function(i, error) {
                if (i.$invalid === true && error === 0) {
                    angular.element('input.ng-invalid').focus();
                    return;
                }
            });
        } else if (error.pattern) {
            angular.forEach(error.pattern, function(i, error) {
                if (i.$invalid === true && error === 0) {
                    angular.element('input.ng-invalid').focus();
                    return;
                }
            });
        }
    }
};

function openLinks (url){
    if (cvsUtility.setNativeCheck()) {
        native.openExtUrl(url);
    }
    else{
        window.open(url)
    }
}

function openLinkinSameWindow(site){
    var url = '';
    switch (site){
        case 'cvs' :
            url = 'https://www.cvs.com'
            break;
        case 'cvsspl' :
            url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env];
            break;
        case 'aboutus' :
            url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env]+CVS.Config.redirectUrls.Web['learnMore'];
            break;
        case 'privacyPolicy' :
            url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env]+CVS.Config.redirectUrls.Web['privacyPolicy'];
            break;
        case 'termsConditions' :
            url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env]+CVS.Config.redirectUrls.Web['termsConditions'];
            break;

    }
    if(parent !== window){
        parent.location.href = url;
    }
    else{
        location.href = url;
    }
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

function scrollToTop(){
    var pa=window.parent.document;
    pa.getElementsByTagName('body')[0].scrollTop = 0;
};

var scrollToSpinner =function(){
    var midd=window.innerHeight ?(window.innerHeight/3):0;
    var pa=window.parent.document;
    pa.getElementsByTagName('body')[0].scrollTop = (midd);
}

/**
 * Method to update service host based on domain to avoid OPTIONS call.
 */
function updateServiceHost() {
    if(window.hasOwnProperty('CVS') && CVS.Config && window.hasOwnProperty('cvsUtility') && cvsUtility.queryMap){
        if(cvsUtility.queryMap["env"] === 'local'){return;}
        else if(cvsUtility.checkIfSuperUser() && cvsUtility.queryMap.env.indexOf('sit1') > -1){
            cvsUtility.queryMap.env = cvsUtility.queryMap.env.replace('www', '');
        }
        else if(cvsUtility.checkIfSuperUser()){ return;}
    CVS.Config.serviceHost[cvsUtility.queryMap["env"]] = location.protocol+"//"+location.host.replace('static', 'www').replace(/green|blue/g, '')+"/api/";
    }
    else{
        updateServiceHost();
}
}

setTimeout(function(){
    window.oo_feedback = new function() {
        this.show = function(){
            oo_tab.show();
        }
    }
}, 1000);


